import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faCheckDouble, faFloppyDiskCircleXmark, faPlay } from "@fortawesome/pro-regular-svg-icons"
import { faCircleXmark, faFile, faFilePen, faPlay as solidFaplay } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { CAMPAIGN_STATUSES } from "campaign/model"

export function getStatusTranslation(status: CAMPAIGN_STATUSES | null, isDspDeal?: boolean): string {
  if (!status || status === CAMPAIGN_STATUSES.TEMPORARY) {
    return translate("label.unsaved")
  }
  return translate(!isDspDeal ? `status.${status}` : `status.dsp-deal.${status}`)
}

export function getStatusColor(status: CAMPAIGN_STATUSES | null): string {
  switch (status) {
    case CAMPAIGN_STATUSES.TEMPORARY:
    case null:
      return "#9f76cb"
    case CAMPAIGN_STATUSES.PENDING:
    case CAMPAIGN_STATUSES.PLANNING:
      return "#9F76CB"
    case CAMPAIGN_STATUSES.REVIEW:
    case CAMPAIGN_STATUSES.RESERVATION:
    case CAMPAIGN_STATUSES.PRICING:
    case CAMPAIGN_STATUSES.ACTIVE:
      return "#5abd51"
    case CAMPAIGN_STATUSES.CANCELLED:
      return "#BF3623"
    case CAMPAIGN_STATUSES.EXPIRED:
      return "#504d50"
  }
}

export function getStatusIconProp(status: CAMPAIGN_STATUSES | null): IconProp {
  switch (status) {
    case CAMPAIGN_STATUSES.TEMPORARY: // unsaved
      return faFloppyDiskCircleXmark
    case CAMPAIGN_STATUSES.PLANNING:
    case CAMPAIGN_STATUSES.PENDING:
      return faFilePen
    case CAMPAIGN_STATUSES.REVIEW:
    case CAMPAIGN_STATUSES.RESERVATION:
    case CAMPAIGN_STATUSES.PRICING:
      return faPlay
    case CAMPAIGN_STATUSES.ACTIVE:
      return solidFaplay
    case CAMPAIGN_STATUSES.CANCELLED:
      return faCircleXmark
    case CAMPAIGN_STATUSES.EXPIRED:
      return faCheckDouble
    case null:
      return faFile
  }
}

export function sortStatus(status1: CAMPAIGN_STATUSES, status2: CAMPAIGN_STATUSES): number {
  const difference = getStatusSortWeight(status1) - getStatusSortWeight(status2)
  if (difference < 0) {
    return -1
  } else if (difference === 0) {
    return 0
  } else {
    return 1
  }
}

function getStatusSortWeight(status: CAMPAIGN_STATUSES): number {
  switch (status) {
    case CAMPAIGN_STATUSES.TEMPORARY:
      return 1
    case CAMPAIGN_STATUSES.PLANNING:
      return 2
    case CAMPAIGN_STATUSES.PENDING:
      return 3
    case CAMPAIGN_STATUSES.REVIEW:
      return 4
    case CAMPAIGN_STATUSES.RESERVATION:
      return 5
    case CAMPAIGN_STATUSES.PRICING:
      return 6
    case CAMPAIGN_STATUSES.ACTIVE:
      return 7
    case CAMPAIGN_STATUSES.CANCELLED:
      return 8
    case CAMPAIGN_STATUSES.EXPIRED:
      return 9
    case null:
      return 10
  }
}
